import React from 'react';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';

import { DeliveryStatus } from '../../common/delivery-status';

export const DeliveryStatusColumn = ({
  i18n, scope, permissions, onRequestException, appealOptions,
}) => ({
  key: 'DeliveryStatus',
  name: i18n.getString(_TL_('Delivery')),
  fieldName: 'DeliveryStatus',
  expandProperties: ['DeliveryStatusDetails'],
  className: 'column-delivery-status',
  headerClassName: 'header-delivery-status',
  minWidth: 120,
  maxWidth: 200,
  sortable: true,
  isMultiline: true,
  isResizable: true,
  onRender: item => (
    <Scenario name="delivery-status">
      <Activity name="delivery-status">
        <DeliveryStatus
          assetGroupId={item.Id}
          DeliveryStatus={item.DeliveryStatus}
          DeliveryStatusDetails={item.DeliveryStatusDetails}
          i18n={i18n}
          scope={scope}
          permissions={permissions}
          onRequestException={onRequestException}
          appealOptions={appealOptions}
        />
      </Activity>
    </Scenario>
  ),
});
